import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Card, Avatar, Typography } from 'antd';
import { LinkedinOutlined, GithubOutlined, MailOutlined, BookOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Hero = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="section section-dark" style={{ 
      paddingTop: '80px',
      paddingBottom: '80px',
      overflow: 'visible',
      minHeight: isMobile ? 'auto' : 'calc(100vh - 64px)'
    }}>
      <div className="container" style={{ overflow: 'visible' }}>
        <Row gutter={[24, 32]} align="middle" style={{ 
          minHeight: isMobile ? 'auto' : 'calc(100vh - 64px)',
          marginBottom: '0'
        }}>
          <Col xs={24} lg={14} order={2} lg={{ order: 1 }}>
            <div className="fade-in-up" style={{ textAlign: isMobile ? 'center' : 'left', marginBottom: isMobile ? '32px' : '0' }}>
              <Title level={1} style={{ 
                color: 'white', 
                fontSize: isMobile ? '2.5rem' : '3.5rem', 
                marginBottom: 16,
                lineHeight: 1.2
              }}>
                Hello, I'm{' '}
                <span style={{ color: '#ffc53d' }}>Katenda Enock</span>
              </Title>
              
              <Title level={2} style={{ 
                color: '#d9d9d9', 
                fontWeight: 'normal', 
                marginBottom: 24,
                fontSize: isMobile ? '1.2rem' : '1.5rem'
              }}>
                Software Engineer | Systems Support Specialist
              </Title>
              
              <Paragraph style={{ 
                color: '#bfbfbf', 
                fontSize: isMobile ? '1rem' : '1.1rem', 
                lineHeight: 1.6,
                maxWidth: '500px',
                marginBottom: 32,
                margin: isMobile ? '0 auto 32px auto' : '0 0 32px 0'
              }}>
                Results-driven professional with 8+ years of experience developing scalable 
                full-stack applications, financial systems, and Linux server solutions. 
                Expert in delivering multitenant SaaS platforms and real-time applications.
              </Paragraph>
              
              <div style={{ 
                display: 'flex', 
                gap: '12px', 
                flexWrap: 'wrap',
                justifyContent: isMobile ? 'center' : 'flex-start'
              }}>
                <Button 
                  type="primary" 
                  size="large"
                  onClick={scrollToContact}
                  style={{ 
                    background: '#ffc53d',
                    borderColor: '#ffc53d',
                    height: '48px',
                    padding: '0 32px',
                    fontSize: '16px'
                  }}
                >
                  Get In Touch
                </Button>
                <Button 
                  size="large"
                  onClick={scrollToAbout}
                  style={{ 
                    color: 'white',
                    borderColor: 'white',
                    backgroundColor: 'transparent',
                    height: '48px',
                    padding: '0 32px',
                    fontSize: '16px'
                  }}
                >
                  Learn More
                </Button>
              </div>
            </div>
          </Col>
          
          <Col xs={24} lg={10} order={1} lg={{ order: 2 }} style={{ 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '0',
            paddingBottom: '0',
            marginBottom: '0'
          }}>
            <div className="fade-in-up" style={{ 
              animationDelay: '0.3s',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <Card
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '20px',
                  textAlign: 'center',
                  padding: isMobile ? '24px' : '32px',
                  width: '100%',
                  maxWidth: isMobile ? '100%' : '400px',
                  margin: '0 auto',
                  boxSizing: 'border-box'
                }}
              >
                <div style={{
                  width: isMobile ? '100px' : '120px',
                  height: isMobile ? '100px' : '120px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  margin: '0 auto 20px auto',
                  border: '4px solid rgba(255, 255, 255, 0.2)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
                }}>
                  <img
                    src="/profile-image.jpeg"
                    alt="Katenda Enock"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'center'
                    }}
                  />
                </div>
                
                <Title level={3} style={{ color: 'white', marginBottom: 8 }}>
                  Katenda Enock
                </Title>
                
                <Paragraph style={{ color: '#d9d9d9', marginBottom: '24px' }}>
                  Software Engineer & Graphics Designer
                </Paragraph>
                
                <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                  <a
                    href="https://linkedin.com/in/katenda-enock-349657143"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    <LinkedinOutlined style={{ color: 'white', fontSize: '24px' }} />
                  </a>
                  <a
                    href="https://github.com/katenda"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    <GithubOutlined style={{ color: 'white', fontSize: '24px' }} />
                  </a>
                  <a
                    href="mailto:katendaenock@gmail.com"
                    style={{ 
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    <MailOutlined style={{ color: 'white', fontSize: '24px' }} />
                  </a>
                  <a
                    href="https://scholar.google.com/citations?user=FMejVSsAAAAJ&hl=en"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      width: '50px',
                      height: '50px',
                      borderRadius: '50%',
                      border: '2px solid rgba(255, 255, 255, 0.3)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      backdropFilter: 'blur(10px)',
                      textDecoration: 'none',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                      e.target.style.transform = 'scale(1.1)';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                      e.target.style.transform = 'scale(1)';
                    }}
                  >
                    <BookOutlined style={{ color: 'white', fontSize: '24px' }} />
                  </a>
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default Hero;